import * as yup from 'yup'
import { notNumRegex, noSelectionRegex, sports, months } from '@assets/constants'
import { IInputProps } from '@views/components/Form'
import { InputTypes } from '@views/components/Input'

export const sportInfoFields: ISportInfoFields = {
  membersNumber: {
    name: 'membersNumber',
    label: 'Number of members',
    type: InputTypes.text,
    placeholder: 'Enter a number',
  },
  sportType: {
    name: 'sportType',
    label: 'Sport type',
    type: InputTypes.picker,
    placeholder: 'Select a sport',
    items: sports,
  },
  seasonStartMonth: {
    name: 'seasonStartMonth',
    label: 'Season start month',
    type: InputTypes.picker,
    placeholder: 'Select a month',
    items: months,
  },
  seasonMonthCount: {
    name: 'seasonMonthCount',
    label: 'Season month count',
    type: InputTypes.slider,
    placeholder: 1,
  },
}

export interface ISportInfoFields {
  membersNumber: IInputProps
  sportType: IInputProps
  seasonStartMonth: IInputProps
  seasonMonthCount: IInputProps
}

export interface ISportInfo {
  membersNumber: string
  sportType: string
  seasonStartMonth: string
  seasonMonthCount: number
}

export const SportInfoSchema = yup.object().shape({
  membersNumber: yup
    .string()
    .required('Required')
    .matches(notNumRegex, 'Invalid Number')
    .min(1, 'Invalid Number')
    .max(5, 'Invalid Number'),
  sportType: yup.string().matches(noSelectionRegex, 'Select a sport').required('Required'),
  seasonStartMonth: yup.string().matches(noSelectionRegex, 'Select a month').required('Required'),
  seasonMonthCount: yup.number().min(1).max(12).required('Required'),
})
